import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Heading,
  LinkBox,
  LinkOverlay,
  Text,
  Tooltip,
  useDisclosure,
} from '@chakra-ui/react'
import React from 'react'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export function Description({ description, completeDescription, item }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef()

  return (
    <>
      <Tooltip label="Clique para ver a descrição completa" placement="top">
        <Box cursor="pointer" onClick={onOpen}>
          {description}
        </Box>
      </Tooltip>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Descrição completa
            </AlertDialogHeader>

            <AlertDialogBody>
              <LinkBox
                as="article"
                maxW="sm"
                p="5"
                borderWidth="1px"
                rounded="md"
              >
                <Heading size="xs" my="2">
                  <Box as="time" dateTime="2021-01-15 15:30:00 +0000 UTC">
                    {
                      //formata a data assim: há 13 dias
                      format(new Date(item.data_abertura), 'PPPPpp', {
                        locale: ptBR,
                      })
                    }
                  </Box>
                </Heading>
                <Heading size="sm" my="2">
                  Descrição:
                </Heading>
                <Text>{completeDescription}</Text>
              </LinkBox>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Fechar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
